import { render, staticRenderFns } from "./SheetForm.vue?vue&type=template&id=1c0f188a&scoped=true"
import script from "./SheetForm.vue?vue&type=script&lang=js"
export * from "./SheetForm.vue?vue&type=script&lang=js"
import style0 from "./SheetForm.vue?vue&type=style&index=0&id=1c0f188a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0f188a",
  null
  
)

export default component.exports